module.exports = __webpack_public_path__ + "static/img/business3.c1e2e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/business3.png
// module id = Udew
// module chunks = 1